module.exports = __webpack_public_path__ + "img/1723016118681-WhatsApp Image 2024-08-07 at 15.33.40.jpeg.d76f06a9.webp";